import cloneDeep from 'lodash.clonedeep';
import { walk } from '../../utils/common.mjs';
import { isMetaplexFile } from '../storageModule/MetaplexFile.mjs';
import { useOperation } from '../../types/Operation.mjs';

const Key = 'UploadMetadataOperation';
const uploadMetadataOperation = useOperation(Key);
const uploadMetadataOperationHandler = {
  handle: async (operation, metaplex) => {
    const rawMetadata = operation.input;
    const files = getAssetsFromJsonMetadata(rawMetadata);
    const assetUris = await metaplex.storage().uploadAll(files);
    const metadata = replaceAssetsWithUris(rawMetadata, assetUris);
    const uri = await metaplex.storage().uploadJson(metadata);
    return {
      uri,
      metadata,
      assetUris
    };
  }
};
const getAssetsFromJsonMetadata = input => {
  const files = [];
  walk(input, (next, value) => {
    if (isMetaplexFile(value)) {
      files.push(value);
    } else {
      next(value);
    }
  });
  return files;
};
const replaceAssetsWithUris = (input, replacements) => {
  const clone = cloneDeep(input);
  let index = 0;
  walk(clone, (next, value, key, parent) => {
    if (isMetaplexFile(value) && index < replacements.length) {
      parent[key] = replacements[index++];
    }

    next(value);
  });
  return clone;
};

export { getAssetsFromJsonMetadata, replaceAssetsWithUris, uploadMetadataOperation, uploadMetadataOperationHandler };
//# sourceMappingURL=uploadMetadata.mjs.map
